import { render, staticRenderFns } from "./RequestItem.vue?vue&type=template&id=44881d5c&scoped=true&"
import script from "./RequestItem.vue?vue&type=script&lang=ts&"
export * from "./RequestItem.vue?vue&type=script&lang=ts&"
import style0 from "./RequestItem.vue?vue&type=style&index=0&id=44881d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44881d5c",
  null
  
)

export default component.exports